import { participantDecorations } from './ParticipantDecoration';
import type { PickedCardAppearance } from '@src/theme/types';
import type { DecoratedCardVariant } from '../DecoratedCard/DecoratedCard';

export const edgeVariants: readonly DecoratedCardVariant[] = [1, 2, 3, 4, 5, 6, 7, 8];

/** Stable ID-based selection: no dependence on render timing, sorting, or grid columns. */
export function cardAppearance(cardId: number): PickedCardAppearance {
  // Mix consecutive IDs before modulo, avoiding vertical stripes in three-column grids.
  let seed = Math.trunc(cardId) >>> 0;
  seed = Math.imul(seed ^ (seed >>> 16), 0x45d9f3b);
  seed = Math.imul(seed ^ (seed >>> 16), 0x45d9f3b);
  seed = (seed ^ (seed >>> 16)) >>> 0;
  const combination = seed % (edgeVariants.length * participantDecorations.length);
  return {
    edges: edgeVariants[combination % edgeVariants.length],
    decoration: participantDecorations[Math.floor(combination / edgeVariants.length)],
  };
}
